import { ConversationStatus, IGetConversationsDTO } from '@/models/conversation.model';
import { PaginationFields } from '@/models/pagination.model';

class GetConversationsDTO implements IGetConversationsDTO {
  conversationId?: string;

  channelId?: number;

  state?: ConversationStatus;

  [PaginationFields.PAGE]?: number;

  [PaginationFields.PAGE_SIZE]?: number;

  constructor({
    page = 1,
    conversationId,
    channelId,
    state,
  }: { page?: number; conversationId?: string; channelId?: number; state?: ConversationStatus } = {}) {
    this.conversationId = conversationId;
    this.channelId = channelId;
    this.state = state;
    this[PaginationFields.PAGE] = page;
    this[PaginationFields.PAGE_SIZE] = 10;
  }
}

export default GetConversationsDTO;
